// common
export const POST_REQUEST = 'report/POST_REQUEST'
export const POST_SUCCESS = 'report/POST_SUCCESS'
export const POST_FAILURE = 'report/POST_FAILURE'

export const UPDATE_ROW_LIST = 'report/UPDATE_ROW_LIST'